// ----------------------------------------------------------------------

export function remToPx(value) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value) {
  return `${value / 16}rem`;
}

export function responsiveFontSizes({ sm, md, lg }) {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm),
    },
    '@media (min-width:900px)': {
      fontSize: pxToRem(md),
    },
    '@media (min-width:1200px)': {
      fontSize: pxToRem(lg),
    },
  };
}

const primaryFont = 'Be Vietnam Pro, sans-serif'; // Google Font
export const secondaryFont = 'Manrope, sans-serif'; // Google Font

// ----------------------------------------------------------------------

export const typography = {
  htmlFontSize: 16,
  '@media (min-width:1024px)': {
    htmlFontSize: 10,
  },
  fontFamily: primaryFont,
  secondaryFontFamily: secondaryFont,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  largeHeading: {
    fontWeight: 800,
    fontSize: pxToRem(36),
  },
  h1: {
    fontWeight: 700,
    fontSize: pxToRem(32),
    lineHeight: '100%',
    letterSpacing: 0,
  },
  h2: {
    fontWeight: 700,
    fontSize: pxToRem(28),
    lineHeight: '100%',
    letterSpacing: 0,
  },
  h3: {
    fontWeight: 700,
    fontSize: pxToRem(24),
    lineHeight: '100%',
    letterSpacing: 0,
  },
  h4: {
    fontWeight: 700,
    fontSize: pxToRem(20),
    lineHeight: '100%',
    letterSpacing: 0,
  },
  h5: {
    fontWeight: 700,
    fontSize: pxToRem(22),
  },
  h6: {
    fontWeight: 700,
    fontSize: pxToRem(20),
  },
  subheading1: {
    fontWeight: 600,
    fontSize: pxToRem(20),
    lineHeight: '100%',
    letterSpacing: 0,
  },
  subheading2: {
    fontWeight: 600,
    fontSize: pxToRem(18),
    lineHeight: '100%',
    letterSpacing: 0,
  },
  paragraph: {
    fontFamily: secondaryFont,
    fontWeight: 400,
    fontSize: pxToRem(16),
    lineHeight: '100%',
  },
  input: {
    fontFamily: secondaryFont,
    fontWeight: 400,
    fontSize: pxToRem(14),
    letterSpacing: '0.2px',
    lineHeight: '100%',
  },
  subtitle1: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(16),
  },
  subtitle2: {
    fontWeight: 600,
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
  },
  body1: {
    lineHeight: 1.5,
    fontSize: pxToRem(16),
  },
  body2: {
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
  },
  caption: {
    fontFamily: secondaryFont,
    fontWeight: 400,
    fontSize: pxToRem(12),
    // lineHeight: '100%',
    letterSpacing: '0.2px',
  },
  overline: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    textTransform: 'uppercase',
  },
  button: {
    fontWeight: 700,
    lineHeight: 24 / 14,
    fontSize: pxToRem(14),
    textTransform: 'unset',
  },
};
